var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo702(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Hamilton_Logo",
    "data-name": "Hamilton Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 188.842,
    height: 78,
    viewBox: "0 0 188.842 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.003,
    x2: 0.5,
    y2: 1.132,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e63af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197,
    stopColor: "#1c5fa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#18579d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#0f498c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#043774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#043673"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "BG",
    width: 188.842,
    height: 78,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HAMILTON_LOGO_4C_2023",
    "data-name": "HAMILTON LOGO_4C_2023",
    transform: "translate(1.234 2.517)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5730",
    "data-name": "Group 5730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5729",
    "data-name": "Group 5729"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1820",
    "data-name": "Path 1820",
    d: "M212.786,88.386l-.02-.044,4.719-10.033H201.572V69.338h0V48.933l-.275-.073a266.467,266.467,0,0,0-146.725.077V69.443h0v8.866h-15.9L43.4,88.342l-.02.044-4.7,10.223h9.577v8.814c.319-.1,1.119-.337,1.41-.42a272.242,272.242,0,0,1,28.952-6.64,266.379,266.379,0,0,0,49.458,4.612,266.371,266.371,0,0,0,49.5-4.621A268.3,268.3,0,0,1,206.492,107c.258.074,1.083.333,1.41.436V98.609h9.585ZM57.7,50.626a263.615,263.615,0,0,1,140.738,0l.425.119V68.858h0V86.651l-1.2-.28V76.184h0V51.552a262.323,262.323,0,0,0-139.182,0V62.6h0V86.373l-1.2.28V69.924h0V50.745Zm2.4,19.817v-17.8a260.611,260.611,0,0,1,135.938,0V68.339h0V86.008a314.951,314.951,0,0,0-135.937,0V70.443ZM48.253,88.919v7.418H42.232L45.9,88.33l-3.652-7.749H54.573S48.286,88.91,48.253,88.919Zm79.82,13.6A264.124,264.124,0,0,1,86.118,99.17c1.267-.183,2.544-.353,3.825-.52a263.137,263.137,0,0,0,38.131,2.773,263.132,263.132,0,0,0,38.179-2.781c1.281.166,2.559.336,3.825.519A264.108,264.108,0,0,1,128.073,102.516Zm77.621,1.976-.133-.037A282.527,282.527,0,0,0,128.076,94.03a282.544,282.544,0,0,0-77.484,10.425l-.133.037V90.606l.078-.021a306.116,306.116,0,0,1,77.539-9.8,306.133,306.133,0,0,1,77.54,9.8l.078.021Zm-4.122-23.911H213.91l-3.652,7.749,3.673,8.007H207.9V88.919C207.872,88.911,201.572,80.582,201.572,80.582Z",
    transform: "translate(-35.512 -36.592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1820_-_Outline",
    "data-name": "Path 1820 - Outline",
    d: "M202.821,105.669l-2.656-.834c-.339-.106-1.08-.339-1.319-.408A267.821,267.821,0,0,0,170.5,97.889a269.116,269.116,0,0,1-49.519,4.589A269.125,269.125,0,0,1,71.51,97.9a271.792,271.792,0,0,0-28.381,6.529l-3.977,1.2V96.111h-10.7l5.639-12.265L28.421,71.794H45.472V42.921l1.453-.419a268.479,268.479,0,0,1,147.84-.078l1.453.419.275,1.584V71.794H213.56l-5.668,12.051,5.639,12.265h-10.71ZM45.379,87.653v9.694a284.922,284.922,0,0,1,75.607-9.831h0a284.683,284.683,0,0,1,75.608,9.831V87.654a304.567,304.567,0,0,0-75.608-9.368A304.451,304.451,0,0,0,45.379,87.653Zm44.786,5.433a262.316,262.316,0,0,0,30.818,1.822A262.34,262.34,0,0,0,151.8,93.087a306.271,306.271,0,0,0-61.632,0Zm112.656-3.264h.886l-.886-1.932Zm-164.547,0h.878V87.907Zm9.9-11.334c-1.893,2.506-3.171,4.2-4.057,5.341q2.023-.52,4.057-1.013Zm145.607,4.324q2.038.494,4.065,1.016c-.888-1.145-2.169-2.834-4.066-5.342Zm4.736-4.729c1.136,1.5,2.4,3.17,3.163,4.17l1.966-4.17Zm-160.192,0,1.963,4.164c.761-1,2.022-2.667,3.154-4.164Zm16.693-28.4V79A317.3,317.3,0,0,1,186.94,79V49.679a258.7,258.7,0,0,0-131.917,0Z",
    transform: "translate(-28.421 -32.086)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1821",
    "data-name": "Path 1821",
    d: "M578.883,190.377l-3.606-7.86,3.652-7.749H566.592v.073l6.24,8.241.089.023v.094l.007.01h-.007v7.315h6.029Z",
    transform: "translate(-400.531 -130.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    d: "M62.541,174.769H50.22l3.652,7.749-3.606,7.86-.067.147h6.021v-7.418l.1-.026,6.221-8.216Z",
    transform: "translate(-43.48 -130.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    d: "M244.056,79.616h0V63.924a260.611,260.611,0,0,0-135.938,0v17.8h0V97.287a314.951,314.951,0,0,1,135.937,0Z",
    transform: "translate(-83.527 -47.87)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    d: "M244.056,79.616h0V63.924a260.611,260.611,0,0,0-135.938,0v17.8h0V97.287a314.951,314.951,0,0,1,135.937,0Z",
    transform: "translate(-83.527 -47.87)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    d: "M276.386,233.871c-1.267-.183-2.545-.353-3.825-.519a263.132,263.132,0,0,1-38.179,2.781,263.136,263.136,0,0,1-38.131-2.773c-1.28.167-2.558.337-3.825.52a264.124,264.124,0,0,0,41.955,3.347A264.109,264.109,0,0,0,276.386,233.871Z",
    transform: "translate(-141.82 -171.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    d: "M240.551,74.375h0V56.263l-.425-.119a263.615,263.615,0,0,0-140.738,0l-.425.119V75.441h0V92.17l1.2-.28V68.115h0V57.07a262.323,262.323,0,0,1,139.182,0V81.7h0V91.888l1.2.28Z",
    transform: "translate(-77.197 -42.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5731",
    "data-name": "Group 5731",
    transform: "translate(29.136 14.568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    d: "M331.3,92.378a.694.694,0,0,0-.5.2.963.963,0,0,0-.237.608c0,3.916-.075,7.831-.075,11.747a.835.835,0,0,0,.816.8h.009l.374-13.352-.38,0Z",
    transform: "translate(-266.414 -88.358)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1828",
    "data-name": "Path 1828",
    d: "M143.611,105.846q1.17-.233,2.341-.455l.144-.027v-4.658l-2.7-3.093v8.276Z",
    transform: "translate(-137.057 -91.979)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1829",
    "data-name": "Path 1829",
    d: "M360.134,93.17a.991.991,0,0,0-.259.735v7.1l.983-8.018-.215-.008A.669.669,0,0,0,360.134,93.17Z",
    transform: "translate(-286.736 -88.776)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    "data-name": "Path 1830",
    d: "M200.087,109.941l.183-.024-1.569-9.3-1.614,9.725.239-.033Q198.706,110.12,200.087,109.941Z",
    transform: "translate(-174.179 -94.059)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    d: "M234.114,97.2a.716.716,0,0,0-.591-.151l-.242.025,1.113,2.319V98.117A1.174,1.174,0,0,0,234.114,97.2Z",
    transform: "translate(-199.205 -91.586)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    "data-name": "Path 1832",
    d: "M451.571,113.653l.2.028V100.437l-.153-.021q-1.16-.16-2.321-.31l-.2-.026v13.244l.155.02Q450.413,113.494,451.571,113.653Z",
    transform: "translate(-348.429 -93.685)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    "data-name": "Path 1833",
    d: "M310.465,103.589l-.089-10.127a1.018,1.018,0,0,0-.244-.751.654.654,0,0,0-.5-.181l-.4.008,1,13.014c.035-.059.23-.191.254-.273C310.5,104.71,310.439,104.188,310.465,103.589Z",
    transform: "translate(-251.721 -88.463)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    "data-name": "Path 1834",
    d: "M123.561,114.873a.611.611,0,0,0-.539-.094l-.176.039.966.967v-.195A.868.868,0,0,0,123.561,114.873Z",
    transform: "translate(-122.846 -103.838)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835",
    "data-name": "Path 1835",
    d: "M531.084,114.753a.569.569,0,0,0-.5.1.881.881,0,0,0-.268.716v.37l.992-1.137Z",
    transform: "translate(-404.587 -103.823)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    "data-name": "Path 1836",
    d: "M506.526,109.157l.039-.049V97.85l-3.395,4.276c1.032,2.156,2.055,4.3,3.057,6.4Z",
    transform: "translate(-385.816 -92.143)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    "data-name": "Path 1837",
    d: "M244.764,106.705l-.071-.015c-1.869-3.869-3.781-7.8-5.682-11.687l-.337-.689v11.21c-1.97-.361-3.972-.705-5.957-1.026v-4.012l.189.03a.637.637,0,0,0,.536-.121.912.912,0,0,0,.249-.725V88.2c0-.8-.456-.991-.729-1.035l-.245-.039V83.115l-1.352,1.967a3.563,3.563,0,0,1,.157.989v15a2.744,2.744,0,0,1-.913,2.123,2.634,2.634,0,0,1-2.142.582c-2.386-.349-4.8-.672-7.18-.96a3.671,3.671,0,0,1-3.114-3.578v-15a3.024,3.024,0,0,1,.314-1.347l-.015,0L216.8,86.314v2.161q-1.848-.195-3.7-.367V85.046c0-.564-.278-.925-.745-.967L211.424,84v12.92c0,.837.484.97.692.989l.5.045v4.015c-2.623-.238-5.287-.444-7.923-.612V97.338l.528.034a.585.585,0,0,0,.444-.15,1,1,0,0,0,.25-.758V83.92c0-.11-.006-.222-.006-.332a1.008,1.008,0,0,1-.138-.027l-.765-.051a.653.653,0,0,0-.5.163.945.945,0,0,0-.243.717v3.035q-1.867-.116-3.735-.208V79.731l-3.787,17.211.854.031a.652.652,0,0,0,.489-.176,1,1,0,0,0,.253-.744v-2.9c1.429.059,2.881.131,4.321.212v7.869c-4.351-.246-8.763-.4-13.121-.445V96.77l.219,0a.774.774,0,0,0,.523-.191,1.011,1.011,0,0,0,.242-.744V84.367c0-.818-.476-.946-.76-.95l-.224,0V79.4l-.806,19.507h-.614v1.868c-.342,0-.688,0-1.031,0-2.208-.006-4.431.007-6.633.051h-.091V98.783l-1.473-19.312v4.017l-.332.008c-.784.021-.784.842-.784,1.15v11.2a1.074,1.074,0,0,0,.276.791.81.81,0,0,0,.6.215l.243-.006v4.017c-2.027.051-4.078.124-6.1.217V86.953l-.341.817q-2.133,5.1-4.265,10.237l-.786.05q-2.074-4.736-4.147-9.443l-.34-.772V101.7c-1.988.159-4,.341-5.981.541V98.226l.264-.027a.987.987,0,0,0,.849-1.091V94.649l-7.111-13.125q1.691,7.976,3.384,15.977c.2.8.7.924,1.092.883l.413-.043v4.015c-1.915.2-3.861.424-5.791.665-.129-.65-.272-1.335-.414-2.019-.153-.737-.306-1.474-.443-2.166l-.032-.163-.165.021c-1.111.142-2.1.278-3.214.433l-.13.018-.02.13c-.114.726-.241,1.5-.368,2.274-.12.733-.241,1.467-.35,2.16-1.844.264-3.709.549-5.548.849v-4.012l.588-.1c.542-.087.864-.444,1.016-1.131q.827-4.775,1.655-9.545l-4.364-6.419v4.012l-.247.041c-.262.044-.7.236-.7,1.033v11.47a.917.917,0,0,0,.251.73.6.6,0,0,0,.508.116l.188-.031v4.012c-2.109.352-4.243.732-6.347,1.131v-9.1l-.211.04q-1.172.223-2.343.456l-.143.028v9.1c-2.12.423-4.252.872-6.342,1.338l18.924,13.845h73.186c5.193,0,10.414-.017,15.626.126l18.963-13.977-.752-.166Q246.782,107.118,244.764,106.705Z",
    transform: "translate(-122.846 -79.38)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    d: "M129.188,106.179l.143-.028q1.171-.232,2.343-.456l.211-.04v9.1c2.1-.4,4.237-.779,6.347-1.131v-4.012l-.188.031a.6.6,0,0,1-.508-.116.917.917,0,0,1-.251-.73V97.323c0-.8.439-.989.7-1.033l.247-.041V92.237c-2.1.351-4.235.731-6.347,1.132v8.276l-.144.027q-1.171.223-2.341.455l-.212.042V93.894c-2.1.42-4.236.87-6.342,1.339v4.008l.176-.039a.611.611,0,0,1,.539.094.868.868,0,0,1,.252.718v11.47c0,.749-.388.993-.714,1.065l-.252.056v4.008c2.09-.465,4.222-.915,6.342-1.338Z",
    transform: "translate(-122.846 -88.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    d: "M176.878,105.219l-.588.1v4.012c1.839-.3,3.7-.585,5.548-.849.11-.694.23-1.427.35-2.16.127-.774.254-1.548.368-2.274l.02-.13.13-.018c1.109-.156,2.1-.291,3.214-.433l.165-.021.032.163c.137.692.29,1.429.443,2.166.142.684.284,1.369.414,2.019,1.93-.241,3.877-.465,5.791-.665v-4.015l-.413.043c-.391.041-.892-.079-1.092-.883q-1.694-8-3.384-15.977c-3.025.369-6.079.791-9.085,1.254v4.013l1.065-.161.243-.037-.042.242q-.255,1.47-.51,2.942-.828,4.771-1.655,9.545C177.742,104.775,177.42,105.132,176.878,105.219Zm7.443-14.509,1.569,9.3-.183.024q-1.382.179-2.761.371l-.239.033Z",
    transform: "translate(-159.799 -84.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M233.545,98.364l-.264.027v4.015c1.983-.2,3.993-.382,5.981-.541V88.006l.34.772q2.072,4.707,4.147,9.443l.786-.05q2.132-5.134,4.265-10.237l.341-.817v14.124c2.025-.093,4.077-.166,6.1-.217V97.007l-.243.006a.81.81,0,0,1-.6-.215,1.074,1.074,0,0,1-.276-.791v-11.2c0-.309,0-1.129.784-1.15l.332-.008V79.635c-2.367.06-4.763.149-7.128.266q-1.917,4.4-3.834,8.825l-.16.37-.165-.368q-1.873-4.175-3.745-8.327c-2.307.178-4.638.385-6.932.617v4.015l.242-.025a.716.716,0,0,1,.591.151,1.174,1.174,0,0,1,.28.914v11.2A.987.987,0,0,1,233.545,98.364Z",
    transform: "translate(-199.205 -79.544)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M309.233,100.785h.091c2.2-.044,4.425-.057,6.633-.051.343,0,.689,0,1.031,0V96.716l-.374,0h-.009a.742.742,0,0,1-.22-.033.653.653,0,0,1-.187-.094.7.7,0,0,1-.149-.149.874.874,0,0,1-.109-.2,1.167,1.167,0,0,1-.065-.242s-.032-.229-.031-.227V84.3a1.273,1.273,0,0,1,.02-.131.963.963,0,0,1,.237-.608.694.694,0,0,1,.5-.2h0l.38,0V79.344c-2.571-.015-5.178,0-7.755.053v4.017l.4-.008a.654.654,0,0,1,.5.181,1.018,1.018,0,0,1,.244.751v11.47a1.418,1.418,0,0,1-.056.408.9.9,0,0,1-.088.212.687.687,0,0,1-.588.333l-.411.008v4.017Z",
    transform: "translate(-251.721 -79.339)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M339.19,83.418c.284,0,.76.131.76.95v11.47a1.011,1.011,0,0,1-.242.744.774.774,0,0,1-.523.191l-.219,0v4.017c4.358.05,8.77.2,13.121.445V93.363c-1.44-.081-2.892-.153-4.321-.212v2.9a1,1,0,0,1-.253.744.652.652,0,0,1-.489.176l-.854-.031-.58-.021-.172-.006V84.508a.991.991,0,0,1,.259-.735.669.669,0,0,1,.509-.187l.215.008V79.578c-2.467-.091-4.967-.151-7.435-.179v4.017Z",
    transform: "translate(-272.279 -79.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M378.319,88.172V85.137a.945.945,0,0,1,.243-.717.652.652,0,0,1,.5-.163l.765.051.145.01V97.21a1,1,0,0,1-.25.758.585.585,0,0,1-.444.15l-.528-.034V102.1c2.636.168,5.3.373,7.923.612V98.7l-.5-.045c-.208-.018-.692-.151-.692-.989V84.743l.936.082c.466.042.745.4.745.967v3.062q1.85.172,3.7.367V81.737c-5.39-.569-10.865-.993-16.279-1.259v7.486Q376.452,88.056,378.319,88.172Z",
    transform: "translate(-296.906 -80.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    d: "M495.043,98.75a.569.569,0,0,1,.5-.1l.228.051V94.691c-1.975-.44-3.983-.866-5.975-1.266v11.39l-.039-.083-.3-.628c-1-2.107-2.025-4.248-3.057-6.4q-1.292-2.7-2.6-5.415c-1.616-.29-3.258-.57-4.885-.833v4.013l.245.039c.273.044.729.238.729,1.035v11.47a.912.912,0,0,1-.249.725.637.637,0,0,1-.536.121l-.189-.03v4.012c1.985.321,3.987.665,5.957,1.026v-11.21l.337.689c1.9,3.886,3.813,7.818,5.682,11.687l.071.015q2.017.413,4.03.855l.752.166v-4.008L495.49,112c-.326-.072-.714-.315-.714-1.065V99.466A.881.881,0,0,1,495.043,98.75Z",
    transform: "translate(-369.043 -87.719)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    d: "M431.775,103.709a3.671,3.671,0,0,0,3.114,3.578c2.378.288,4.794.611,7.18.96a2.634,2.634,0,0,0,2.142-.582,2.744,2.744,0,0,0,.913-2.123v-15a3.564,3.564,0,0,0-.157-.989,3.776,3.776,0,0,0-2.95-2.709c-2.37-.347-4.783-.67-7.172-.959a3.009,3.009,0,0,0-.359-.022,2.647,2.647,0,0,0-1.774.661,2.7,2.7,0,0,0-.623.837,3.024,3.024,0,0,0-.314,1.347Zm5.346-13.463.2.026q1.161.15,2.321.31l.153.021v13.244l-.2-.028q-1.159-.16-2.318-.31l-.155-.02Z",
    transform: "translate(-336.45 -83.852)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1846",
    "data-name": "Path 1846",
    d: "M232.1,185.246l-.078-.021a311.6,311.6,0,0,0-155.079,0l-.078.021v13.886L77,199.1a282.544,282.544,0,0,1,77.484-10.425A282.527,282.527,0,0,1,231.966,199.1l.133.037Z",
    transform: "translate(-61.916 -131.233)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5733",
    "data-name": "Group 5733",
    transform: "translate(3.164 2.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5732",
    "data-name": "Group 5732"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    "data-name": "Path 1847",
    d: "M212.786,88.386l-.02-.044,4.719-10.033H201.572V69.338h0V48.933l-.275-.073a266.467,266.467,0,0,0-146.725.077V69.443h0v8.866h-15.9L43.4,88.342l-.02.044-4.7,10.223h9.577v8.814c.319-.1,1.119-.337,1.41-.42a272.242,272.242,0,0,1,28.952-6.64,266.379,266.379,0,0,0,49.458,4.612,266.371,266.371,0,0,0,49.5-4.621A268.3,268.3,0,0,1,206.492,107c.258.074,1.083.333,1.41.436V98.609h9.585ZM57.7,50.626a263.615,263.615,0,0,1,140.738,0l.425.119V68.858h0V86.651l-1.2-.28V76.184h0V51.552a262.323,262.323,0,0,0-139.182,0V62.6h0V86.373l-1.2.28V69.924h0V50.745Zm2.4,19.817v-17.8a260.611,260.611,0,0,1,135.938,0V68.339h0V86.008a314.951,314.951,0,0,0-135.937,0V70.443ZM48.253,88.919v7.418H42.232L45.9,88.33l-3.652-7.749H54.573S48.286,88.91,48.253,88.919Zm79.82,13.6A264.124,264.124,0,0,1,86.118,99.17c1.267-.183,2.544-.353,3.825-.52a263.137,263.137,0,0,0,38.131,2.773,263.132,263.132,0,0,0,38.179-2.781c1.281.166,2.559.336,3.825.519A264.108,264.108,0,0,1,128.073,102.516Zm77.621,1.976-.133-.037A282.527,282.527,0,0,0,128.076,94.03a282.544,282.544,0,0,0-77.484,10.425l-.133.037V90.606l.078-.021a306.116,306.116,0,0,1,77.539-9.8,306.133,306.133,0,0,1,77.54,9.8l.078.021Zm-4.122-23.911H213.91l-3.652,7.749,3.673,8.007H207.9V88.919C207.872,88.911,201.572,80.582,201.572,80.582Z",
    transform: "translate(-38.676 -38.601)",
    fill: "#043673"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5734",
    "data-name": "Group 5734",
    transform: "translate(19.216 46.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    d: "M94.3,213.4v1.018a2.205,2.205,0,0,1-1.812,2.368l-.575.139v2.943l-1.214.3v-7.833q.893-.222,1.789-.438C93.7,211.6,94.3,212.144,94.3,213.4Zm-2.387-.245V215.8l.575-.139c.385-.093.6-.323.6-.882v-1.176c0-.559-.21-.688-.6-.595Z",
    transform: "translate(-90.696 -203.365)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    d: "M107.132,208.933l1.218-.278v6.714q1-.226,2.005-.446v1.119q-1.613.353-3.223.723Q107.133,212.849,107.132,208.933Z",
    transform: "translate(-102.061 -201.179)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    d: "M123.271,204.287v6.043c0,.559.243.71.633.63s.632-.333.633-.892q0-3.021,0-6.043l1.156-.235v5.964a2.169,2.169,0,0,1-1.822,2.342c-1.2.249-1.822-.332-1.821-1.587q0-2.982,0-5.964Z",
    transform: "translate(-112.375 -197.814)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    d: "M141.678,205.665q.418-2.859.835-5.716.853-.156,1.706-.308v7.833l-1.16.208v-5.617l-.847,5.773-1.158.216q-.457-2.683-.913-5.366v5.539l-1.068.207V200.6q.851-.166,1.7-.328Q141.227,202.968,141.678,205.665Z",
    transform: "translate(-124.146 -194.944)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    d: "M164.8,199.088v.279a1.823,1.823,0,0,1-.794,1.706c.662.151.916.7.917,1.532v.638a2.009,2.009,0,0,1-1.866,2.16q-.966.16-1.931.326v-7.833q.927-.159,1.853-.313C164.247,197.372,164.794,197.88,164.8,199.088Zm-2.447-.282q0,1.035,0,2.07l.48-.08c.457-.076.738-.323.737-.95v-.437c0-.56-.191-.775-.626-.7Zm0,3.189q0,1.2,0,2.406l.7-.117c.414-.068.637-.295.637-.876q0-.341,0-.683c0-.728-.235-.914-.793-.821Z",
    transform: "translate(-139.39 -193.488)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    d: "M178.424,195.461l1.231-.187v7.833l-1.231.187Q178.425,199.378,178.424,195.461Z",
    transform: "translate(-151.354 -191.924)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    d: "M188.846,195.289v5.674l-1.109.158v-7.833q.772-.111,1.546-.219l1.266,4.516V192.9l1.1-.146v7.833l-1.266.168Q189.614,198.018,188.846,195.289Z",
    transform: "translate(-157.794 -190.178)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    d: "M207.517,194.569q.864-.1,1.729-.2v2.484a1.964,1.964,0,0,1-1.841,2.183c-1.213.146-1.841-.491-1.84-1.744v-4.073a1.973,1.973,0,0,1,1.84-2.195c1.212-.144,1.843.5,1.841,1.755v.761l-1.168.134v-.839c0-.559-.247-.743-.64-.7s-.64.289-.64.849v4.23c0,.559.246.731.64.684s.64-.277.64-.836v-1.443l-.561.066Z",
    transform: "translate(-170.121 -188.97)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    d: "M233.449,196.3a1.4,1.4,0,0,1,1.563,1.414,1.74,1.74,0,0,1-1.563,1.7,1.39,1.39,0,0,1-1.563-1.406A1.747,1.747,0,0,1,233.449,196.3Z",
    transform: "translate(-188.32 -192.629)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    d: "M258,194.177l-1.239.088v-7.833l1.239-.088V189.7q.7-.048,1.408-.093V186.25l1.262-.078v7.833l-1.262.078v-3.357q-.7.045-1.408.093Z",
    transform: "translate(-205.518 -185.628)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    "data-name": "Path 1858",
    d: "M276.079,188.729q.851-.043,1.7-.081v1.119q-.851.038-1.7.081v2.294q1.071-.054,2.142-.1v1.119q-1.691.073-3.382.165v-7.833q1.691-.092,3.382-.165v1.119q-1.071.046-2.142.1Z",
    transform: "translate(-218.019 -185.044)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    "data-name": "Path 1859",
    d: "M294.689,192.607l-1.252.033q-.108-.708-.215-1.415-.761.022-1.523.048-.107.714-.215,1.429l-1.139.042q.633-3.941,1.264-7.879.908-.031,1.815-.057Zm-2.831-2.4,1.2-.038-.6-3.943Q292.157,188.214,291.858,190.2Z",
    transform: "translate(-228.741 -184.684)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    d: "M306.88,184.508q1.918-.042,3.837-.06v1.119l-1.3.015V192.3l-1.241.019q0-3.357,0-6.714l-1.3.026Z",
    transform: "translate(-240.173 -184.436)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    d: "M324.029,184.41l1.242,0v7.833l-1.242,0Z",
    transform: "translate(-252.031 -184.407)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    d: "M334.537,186.587v5.674l-1.116-.008V184.42q.778,0,1.557.012.638,2.351,1.275,4.7v-4.689l1.106.018V192.3l-1.274-.02Q335.31,189.43,334.537,186.587Z",
    transform: "translate(-258.524 -184.416)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    "data-name": "Path 1863",
    d: "M353.33,188.1q.869.026,1.737.057v2.484c0,1.254-.633,1.946-1.85,1.909a1.774,1.774,0,0,1-1.85-2.018V186.46c0-1.253.633-1.956,1.85-1.921a1.782,1.782,0,0,1,1.85,2.029v.761l-1.173-.039v-.839c0-.56-.249-.78-.643-.791s-.645.194-.643.754v4.23c0,.56.249.767.643.779s.643-.182.643-.741v-1.443l-.564-.017Z",
    transform: "translate(-270.933 -184.498)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    "data-name": "Path 1864",
    d: "M379.364,193.566a1.668,1.668,0,0,1,1.567,1.646,1.454,1.454,0,0,1-1.567,1.465,1.661,1.661,0,0,1-1.566-1.638A1.462,1.462,0,0,1,379.364,193.566Z",
    transform: "translate(-289.208 -190.741)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    d: "M405.98,195.534l-1.249-.108q-.107-.72-.214-1.439-.76-.064-1.52-.124l-.214,1.4-1.137-.087,1.261-7.737q.906.071,1.812.148Q405.349,191.561,405.98,195.534Zm-2.825-2.722,1.193.1q-.3-2.005-.6-4.01Q403.452,190.855,403.154,192.812Z",
    transform: "translate(-305.697 -186.507)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    d: "M423.62,194.109v1.04c0,1.253-.631,1.9-1.844,1.781a1.919,1.919,0,0,1-1.844-2.147V190.71c0-1.253.63-1.912,1.844-1.792a1.929,1.929,0,0,1,1.844,2.158v.761l-1.169-.121v-.839c0-.56-.248-.8-.641-.836s-.639.149-.641.709v4.23c0,.56.247.785.641.824s.64-.137.641-.7v-1.119Z",
    transform: "translate(-318.341 -187.518)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    d: "M447.676,199.71a1.816,1.816,0,0,1,1.559,1.755,1.339,1.339,0,0,1-1.559,1.356,1.812,1.812,0,0,1-1.559-1.747A1.345,1.345,0,0,1,447.676,199.71Z",
    transform: "translate(-336.447 -194.983)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    d: "M473.47,202.976a2.557,2.557,0,0,1-.112-.98v-1.231c0-.727-.244-1.035-.805-1.119l-.425-.064q0,1.595,0,3.19c-.411-.062-.82-.122-1.232-.182q0-3.917,0-7.833.929.136,1.858.277a1.876,1.876,0,0,1,1.823,2.085q0,.308,0,.615c0,.806-.259,1.291-.805,1.462a1.861,1.861,0,0,1,.816,1.8V202.2a2.446,2.446,0,0,0,.134.972Zm-1.342-6.919q0,1.2,0,2.406l.481.073c.459.069.738-.089.738-.715v-.772c0-.56-.19-.835-.626-.9Z",
    transform: "translate(-353.58 -191.565)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    d: "M487.8,199.666c0-1.252.66-1.863,1.865-1.658a2.122,2.122,0,0,1,1.863,2.292v4.073c0,1.253-.658,1.852-1.863,1.647a2.113,2.113,0,0,1-1.865-2.281Zm1.229,4.355c0,.56.246.813.636.88s.638-.1.636-.664v-4.23c0-.559-.246-.814-.636-.881s-.636.1-.636.664Z",
    transform: "translate(-365.27 -193.788)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    "data-name": "Path 1870",
    d: "M504.8,202.659c0-1.253.658-1.851,1.861-1.625a2.163,2.163,0,0,1,1.858,2.325v4.073c0,1.253-.656,1.84-1.858,1.614a2.154,2.154,0,0,1-1.861-2.313Zm1.226,4.377c0,.56.247.818.635.891s.636-.093.635-.652v-4.23c0-.56-.245-.818-.635-.892s-.635.093-.635.653Z",
    transform: "translate(-377.022 -195.875)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    "data-name": "Path 1871",
    d: "M521.251,203.448q1.89.377,3.777.777v1.119l-1.276-.268v6.714l-1.222-.251v-6.714l-1.279-.258Z",
    transform: "translate(-388.397 -197.577)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1872",
    "data-name": "Path 1872",
    d: "M539.349,210.537q.837.186,1.672.376v1.119q-.835-.19-1.672-.376v2.294q1.052.234,2.1.474v1.119q-1.66-.38-3.323-.742v-7.833q1.664.362,3.323.742v1.119q-1.051-.241-2.1-.474Z",
    transform: "translate(-400.068 -200.012)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1873",
    "data-name": "Path 1873",
    d: "M556.42,218.972a2.669,2.669,0,0,1-.111-.99v-1.23c0-.727-.241-1.055-.8-1.189l-.419-.1v3.189l-1.216-.288q0-3.917,0-7.833.918.216,1.834.437a2.069,2.069,0,0,1,1.8,2.242v.615c0,.806-.257,1.269-.795,1.393a2.037,2.037,0,0,1,.806,1.866v1.209a2.606,2.606,0,0,0,.132.984Q557.039,219.123,556.42,218.972Zm-1.325-7.034v2.406l.474.114c.453.109.727-.026.729-.652v-.772c0-.56-.187-.851-.619-.955Z",
    transform: "translate(-410.957 -202.477)",
    fill: "#043673"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5735",
    "data-name": "Group 5735",
    transform: "translate(169.069 36.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1874",
    "data-name": "Path 1874",
    d: "M577.394,152.184a.292.292,0,0,0-.135-.093.484.484,0,0,0-.161-.03.414.414,0,0,0-.091.011.352.352,0,0,0-.089.033.2.2,0,0,0-.068.059.149.149,0,0,0-.026.089.147.147,0,0,0,.063.128.592.592,0,0,0,.158.076q.1.031.205.063a.852.852,0,0,1,.2.089.487.487,0,0,1,.158.154.471.471,0,0,1,.063.259.591.591,0,0,1-.058.269.539.539,0,0,1-.155.191.659.659,0,0,1-.227.112,1,1,0,0,1-.273.037.991.991,0,0,1-.334-.055.84.84,0,0,1-.288-.178l.29-.319a.425.425,0,0,0,.158.129.444.444,0,0,0,.3.034.33.33,0,0,0,.091-.035.2.2,0,0,0,.065-.06.15.15,0,0,0,.025-.086.157.157,0,0,0-.064-.132.592.592,0,0,0-.161-.082q-.1-.034-.209-.068a.944.944,0,0,1-.209-.091.5.5,0,0,1-.161-.151.432.432,0,0,1-.064-.248.554.554,0,0,1,.058-.261.565.565,0,0,1,.157-.188.675.675,0,0,1,.226-.114.926.926,0,0,1,.264-.038,1.039,1.039,0,0,1,.3.045.7.7,0,0,1,.264.149Z",
    transform: "translate(-576.341 -151.686)",
    fill: "#043673"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1875",
    "data-name": "Path 1875",
    d: "M581.651,151.838h.617l.426,1.206h.005l.429-1.206h.614v1.849h-.408v-1.418h-.006l-.486,1.418h-.311l-.468-1.418h-.005v1.418h-.408Z",
    transform: "translate(-580.012 -151.791)",
    fill: "#043673"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo702);
export default __webpack_public_path__ + "static/media/logo_702.237def632730c3c0a98d81c512a1e757.svg";
export { ForwardRef as ReactComponent };